import { useEffect, useContext } from "react"
import { ThemeContext } from ".."
import BtnKeyboard from "./images/dialpad.svg?url"
import BtnMute from "./images/muted.svg?url"
import BtnPause from "./images/paused.svg?url"

import { style as defaultStyle, images as DefaultImages } from "../default"

import style from "./style.css?inline"
const images = { ...DefaultImages, BtnKeyboard, BtnMute, BtnPause }

const Theme = () => {
    const { setImages, addStyle /*, addArtifact*/ } = useContext(ThemeContext)
    useEffect(() => {
        addStyle("default", defaultStyle)
        addStyle("propstream", style)

        // const fontEl = document.createElement("link")
        // fontEl.rel = "stylesheet"
        // fontEl.type = "text/css"
        // fontEl.href = "//rsms.me/inter/inter.css"
        // addArtifact("fontInter", fontEl)

        setImages(images)
    }, [])
    return <></>
}

export default Theme
